import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface PaymentsAppealsState {
  storeName?: string
  documents?: IFile[]
  purses?: IPurse[]
  submitted: boolean
  amount: number
}

export type IPurse = {
  id: number
  title: string
  amount: number
}

export type IFile = {
  name: string
  base64: string
  type: string
}

const initialState: PaymentsAppealsState = {
  storeName: '',
  documents: [],
  purses: [],
  submitted: false,
  amount: 0,
}

const paymentsAppealsSlice = createSlice({
  name: 'paymentsAppealsApplication',
  initialState,
  reducers: {
    setStoreName(state, action: PayloadAction<string>) {
      state.storeName = action.payload
    },

    setUploadedDocuments(state, action: PayloadAction<IFile[]>) {
      state.documents = action.payload
    },

    setPurses(state, action: PayloadAction<IPurse[]>) {
      state.purses = action.payload
    },

    setSubmissionStatus(state, action: PayloadAction<boolean>) {
      state.submitted = action.payload
    },

    setPaymentAppealState(state, action: PayloadAction<Partial<PaymentsAppealsState>>) {
      return { ...state, ...action.payload }
    },

    resetAppealsState: () => initialState,
  },
})

export const {
  setStoreName,
  setPaymentAppealState,
  setUploadedDocuments,
  setPurses,
  setSubmissionStatus,
  resetAppealsState,
} = paymentsAppealsSlice.actions

export default paymentsAppealsSlice.reducer
